import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import { useAppDispatch } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { messages } from "utils/CommonConstants";
import { setShowDeleteInncodeDialog } from "./sme.slice";

interface Props {
  open: boolean;
  deleteMapping: (args: any) => void;
}

const DeleteDialog = (props: Props) => {
  const dispatch = useAppDispatch();
  const { open, deleteMapping } = props;

  const handleClose = () => {
    dispatch(setShowDeleteInncodeDialog({ show: false, id: null }));
  };

  return (
    <DialogFormation
      openDialog={open}
      handleClose={handleClose}
      title="Delete Inncode"
      actionConfig={
        <div className="modal-config-wrapper">
          <Button label="Cancel" variant="secondary" onClick={handleClose} />
          <Button
            variant="alert"
            label="Delete"
            onClick={deleteMapping}
            sx={{
              backgroundColor: tokens.Icon.Feeback.Alert,
              color: tokens.Text.General.Inverse,
              "&:hover": { color: tokens.Icon.Feeback.Alert }
            }}
          />
        </div>
      }
    >
      <Typography variant="body1" color={tokens.Text.General.PrimaryHeadline} sx={{ textAlign: "center" }}>
        {messages.deleteInncodeConfirm}
      </Typography>
    </DialogFormation>
  );
};

export default DeleteDialog;
